import { GridSelect } from 'components/FeaturedSpreadsheet/components';
import { getObjectValue } from 'utilities';
import getOptionsAccordingApproach from './getOptionsAccordingApproach';
import multipleTypeApproachListStyles from './MultipleTypeApproachSelect.styles';
import { MultipleTypeApproachProps } from './types';

const MultipleTypeApproachSelect = (props: MultipleTypeApproachProps) => {
  const { cell } = getObjectValue(props);
  const options = getOptionsAccordingApproach(cell);

  return (
    <GridSelect
      extraStyles={multipleTypeApproachListStyles}
      options={options}
      optionsTextAlign="right"
      useHandleChange={false}
      {...props}
    />
  );
};

export default MultipleTypeApproachSelect;
